export default "/static/js/bin/images/fac7da935457a6564581b726ea008f7e.png";